<template>
  <div class="row" v-if="this.isMounted && newCart">
    <div class="col-md-12 input-position text-center">
      <ul slot="raw-content" class="list-group list-group-flush delivery-pickup-menu">
        <li class="list-group-item">
          <div class="btn-group">
            <div class="order-type-button form-check form-check-button" v-if="isDeliveryButtonVisible">
              <n-button @click="onOrderTypeChanged(ORDER_TYPE.Delivery.id)" :style="[
                newCart.orderType === ORDER_TYPE.Delivery.id
                  ? myTheme.servicesButton.active
                  : myTheme.servicesButton.normal,
              ]" v-html="buttonText(ORDER_TYPE.Delivery.id)"></n-button>
            </div>
            <div class="order-type-button form-check form-check-button" v-if="isCollectionButtonVisible">
              <n-button @click="onOrderTypeChanged(ORDER_TYPE.Collection.id)" :style="[
                newCart.orderType === ORDER_TYPE.Collection.id
                  ? myTheme.servicesButton.active
                  : myTheme.servicesButton.normal,
              ]" v-html="buttonText(ORDER_TYPE.Collection.id)"></n-button>
            </div>
            <div class="order-type-button form-check form-check-button" v-if="isTableButtonVisible">
              <n-button @click="onOrderTypeChanged(ORDER_TYPE.Table.id)" :style="[
                newCart.orderType === ORDER_TYPE.Table.id
                  ? myTheme.servicesButton.active
                  : myTheme.servicesButton.normal,
              ]" v-html="buttonText(ORDER_TYPE.Table.id)"></n-button>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="col-md-12 centered add-padding-top-10">
      <div class="list-group list-group-flush search-area" role="group" aria-label="..." v-if="isPostcodeSearchVisible">
        <div class="input-group">
          <fg-input class="input-lg" :placeholder="$t('input.placeholder.search_postCode')" v-model.lazy="searchPostcode"
            oninput="this.value = this.value.toUpperCase()" v-on:keyup="validatePostcode"></fg-input>
          <!--allLocationsClosed(ORDER_TYPE.Delivery.id) ||-->
          <n-button :disabled="!searchPostcode || !searchPostcode.length" type="primary" @click="searchLocationbyPostcode"
            round icon class="add-on-input" :style="myTheme.customizeButton">
            <i :class="[
              { 'now-ui-icons ui-1_zoom-bold': !isLoadingSearch },
              { 'k-icon-spin5': isLoadingSearch },
            ]"></i>
          </n-button>
        </div>
        <div v-if="searchError">
          <div class="form-group input-group">
            <el-alert :title="searchErrorText" type="error" :closable="false"></el-alert>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 centered">
      <div class="form-group input-group search-area" v-if="isLocationSelectionVisible">
        <el-select v-model="location_id" :placeholder="$t('input.placeholder.select_location')"
          @input="onLocationSelected">
          <el-option v-for="(location, index) in filteredLocations" :key="index" :label="location.name"
            :value="location.id">{{ location.name }}</el-option>
        </el-select>
      </div>
    </div>

    <div class="col-md-12 centered add-padding-top-10" v-if="
      newCart.orderType === ORDER_TYPE.Table.id &&
      ((isHome && filteredLocations.length) || (!isHome && selectedLocation))
    ">
      <div class="form-group input-group search-area justify-content-center" role="group">
        <div v-if="!isHome && showTable && newCart.table">
          <h3>{{ newCart.table.name }}</h3>
          <p>{{ $t("text.change_table_number") }}</p>
        </div>

        <el-select v-if="selectedLocation" v-model="table_id" :placeholder="$t('input.placeholder.select_table')"
          @change="onTableSelection">
          <el-option v-for="(table, index) in selectedLocation.tables" :key="index" :label="table.name" :value="table.id">
            <span style="float: left">{{ table.name }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">
              {{ `${$t("text.capacity")} : ${table.capacity}` }}</span>
          </el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { RadioButton, FormGroupInput, Button } from "@/components";
import { cartManager } from "@/utilities";
import { couponMixin } from "@/mixins";
import { ORDER_TYPE, STEP_STATUS, STEPS } from "@/utilities/enums";
import {
  getMenuItemTotal,
  canMakeOrder,
  getMessageFromAPIError,
  checkIfItemAvailbleByOrderType,
  filterLocationsByOrderType,
  getServiceChargeByType,
} from "@/utilities/helper";

export default {
  mixins: [couponMixin],
  components: {
    [RadioButton.name]: RadioButton,
    [FormGroupInput.name]: FormGroupInput,
    [Button.name]: Button,
  },
  data() {
    return {
      ORDER_TYPE,
      isMounted: false,
      searchPostcode: "",
      location_id: null,
      table_id: null,
      searchError: false,
      searchErrorText: "",
      filteredLocations: [],
      hasCompletedPostcodeLookup: false,
      ItemsWithDiffPrice: [],
      ItemsNotAvailable: [],
      isLoadingSearch: false,
    };
  },
  props: {
    small: Boolean,
    isHome: Boolean,
    showTable: Boolean,
  },
  computed: {
    ...mapState('locationStore', ['availableLocations']),
    ...mapState('cartStore', ["postcode"]),
    locationStatus() {
      return canMakeOrder(this.selectedLocation, this.isMounted);
    },
    multiLocations() {
      //!multiLocations &&  check in the template
      if (!this.isMounted) return false;
      return this.locations.length > 1;
    },
    isLocationSelectionVisible() {
      const {
        isHome,
        filteredLocations,
        multiLocations,
        hasCompletedPostcodeLookup,
      } = this;

      if (isHome) {
        switch (this.newCart.orderType) {
          case ORDER_TYPE.Delivery.id:

            return (
              filteredLocations &&
              filteredLocations.length > 1 &&
              hasCompletedPostcodeLookup &&
              !this.allLocationsClosed(ORDER_TYPE.Delivery.id)
            );

          case ORDER_TYPE.Collection.id:
            return (
              multiLocations &&
              !this.allLocationsClosed(ORDER_TYPE.Collection.id)
            );

          case ORDER_TYPE.Table.id:
            return !this.allLocationsClosed(ORDER_TYPE.Table.id);
        }
      }
      return false;
    },
    isPostcodeSearchVisible() {
      const { isHome, multiLocations } = this;
      return (
        ((isHome && multiLocations) ||
          (isHome &&
            !multiLocations &&
            this.locations.length &&
            this.locations[0].orderSetting.offer_delivery)) &&
        this.newCart.orderType === ORDER_TYPE.Delivery.id
      );
    },
    isDeliveryButtonVisible() {
      const { isHome, selectedLocation, multiLocations } = this;
      return (
        (isHome && multiLocations) ||
        (isHome &&
          !multiLocations &&
          selectedLocation &&
          selectedLocation.orderSetting.offer_delivery) ||
        (!isHome &&
          selectedLocation &&
          selectedLocation.orderSetting.offer_delivery)
      );
    },
    isCollectionButtonVisible() {
      const { isHome, selectedLocation, multiLocations } = this;
      return (
        (isHome && multiLocations) ||
        (isHome &&
          !multiLocations &&
          selectedLocation &&
          selectedLocation.orderSetting.offer_collection) ||
        (!isHome &&
          selectedLocation &&
          selectedLocation.orderSetting.offer_collection)
      );
    },
    isTableButtonVisible() {
      const { isHome, selectedLocation, multiLocations } = this;
      const { can_make_order, can_accept_tableOrdering } = this.locationStatus;

      return (
        (isHome && multiLocations && this.businessAllowingTableOrdering()) ||
        (isHome &&
          !multiLocations &&
          can_make_order &&
          can_accept_tableOrdering &&
          !this.isLocationEmpty() &&
          selectedLocation.tables.length) ||
        (!isHome &&
          can_make_order &&
          can_accept_tableOrdering &&
          selectedLocation.tables.length)
      );
    },
  },
  watch: {
    'newCart.order'(newOrderValue) {
      if (newOrderValue.length) {
        this.cartCheckerInterval = setInterval(this.checkCartExpiration, 60 * 5 * 1000);
      } else {
        clearInterval(this.cartCheckerInterval);
      }
    },
    'newCart.orderType'(newOrderType) {
      if (this.selectedLocation) {

        this.$set(this.newCart, 'service_charge', getServiceChargeByType(
          this.selectedLocation.service_charges,
          newOrderType,
          this.selectedLocation.orderSetting.service_charge
        ))
        cartManager.setCart(this.newCart, true, false);
      }
    },
    selectedLocation: {
      deep: true,
      handler: function (newLocation) {

        this.$set(this.newCart, 'bag_charge', newLocation
          ? parseFloat(newLocation.orderSetting.bag_charge)
          : 0.0)

        this.$set(this.newCart, 'service_charge', newLocation
          ? getServiceChargeByType(
            this.selectedLocation.service_charges,
            this.newCart.orderType,
            this.selectedLocation.orderSetting.service_charge
          )
          : 0.0);

        this.$set(this.newCart, 'is_deliverect', newLocation ? newLocation.is_deliverect : false)
        this.$set(this.newCart, 'locationId', newLocation.id || this.selectedLocation.id)

        cartManager.setCart(this.newCart, true, false);
      },
    },
  },
  methods: {
    ...mapActions('locationStore', [
      "fetchLocationsByPostCode",
      "fetchTheme",
      "fetchCategories",
      'storeSelectedLocation'
    ]),
    ...mapActions('cartStore', ['savePostcode']),
    buttonText(value) {
      const {
        can_make_order,
        can_accept_delivery,
        can_accept_collection,
        can_accept_tableOrdering,
        openingHours,
      } = this.locationStatus;

      let result = "<div class='options-container'>";
      switch (value) {
        case this.ORDER_TYPE.Delivery.id:
          result += `<div class='option-top'><i class='k-icon-cab'></i> ${this.$t(
            "button.delivery"
          )}</div>`;
          break;
        case this.ORDER_TYPE.Collection.id:
          result += `<div class='option-top'><i class='k-icon-pick-up'></i> ${this.$t(
            "button.collection"
          )}</div>`;
          break;
        case this.ORDER_TYPE.Table.id:
          result += `<div class='option-top'><i class='k-icon-table-ordering'></i> ${this.$t(
            "button.table"
          )}</div>`;
          break;
      }

      if (this.multiLocations && this.isHome) {
        //---- check if all locations are closed by ordertype (if true add closed)
        if (this.allLocationsClosed(value)) {
          result += `<div class='option-bottom closed'>${this.$t(
            "button.closed"
          )}</div>`;
        }
        result += "</div>";
        return result;
      }

      if (!can_make_order) {
        result += this.selectedLocation.openingHours.suspended
          ? `<div class='option-bottom'>${this.$t(
            "text.not_taking_orders_right_now"
          )}</div></div>`
          : `<div class='option-bottom closed'>${this.$t(
            "button.closed"
          )}</div></div>`;

        return result;
      }
      //--- open / pre-order
      switch (value) {
        case this.ORDER_TYPE.Delivery.id:
          result += openingHours.delivery
            ? `<div class='option-bottom'>${this.$t("button.open")}</div>`
            : can_accept_delivery
              ? `<div class='option-bottom'>${this.$t(
                "button.pre_order"
              )}</div>` +
              "<div class='option-time'>" +
              this.getPreOrderTime(this.selectedLocation.delivery_time) +
              "</div>"
              : `<div class='option-bottom closed'>${this.$t(
                "button.closed"
              )}</div></div>`;

          break;
        case this.ORDER_TYPE.Collection.id:
          result += openingHours.collection
            ? `<div class='option-bottom'>${this.$t("button.open")}</div>`
            : can_accept_collection
              ? `<div class='option-bottom'>${this.$t(
                "button.pre_order"
              )}</div>` +
              "<div class='option-time'>" +
              this.getPreOrderTime(this.selectedLocation.pickup_time) +
              "</div>"
              : `<div class='option-bottom closed'>${this.$t(
                "button.closed"
              )}</div></div>`;

          break;
        case this.ORDER_TYPE.Table.id:
          result += can_accept_tableOrdering
            ? `<div class='option-bottom'>${this.$t("button.open")}</div>`
            : `<div class='option-bottom closed'>${this.$t(
              "button.closed"
            )}</div></div>`;

          break;
      }
      return result;
    },
    getPreOrderTime(dates_collection) {
      let array_dates = Object.keys(dates_collection);
      let time = "";
      if (!array_dates.length) return time;
      let now = this.$moment();

      for (let k = 0; k < array_dates.length; k++) {
        let str_elemnt = array_dates[k];
        var date_values = dates_collection[str_elemnt];
        if (!date_values) continue;
        let date_element = this.$moment(str_elemnt, "YYYY-MM-DD"); // display only time or Tomorrow + time or day name + time

        //--- if the first element is today
        if (date_element.isSame(this.$moment(now), "day")) {
          //--- check the time depend in today
          for (let i = 0; i < date_values.length; i++) {
            if (
              now.isSameOrBefore(
                this.$moment(
                  now.format("YYYY-MM-DD") + " " + date_values[i].closes_at,
                  "YYYY-MM-DD  HH:mm"
                )
              )
            ) {
              let formatTime = date_values[i].opens_at.split(":");
              time = `${formatTime[0]}:${formatTime[1]}`;
              return time;
            }
          }
        } else if (date_element.isAfter(now)) {
          //--- if the first element is in the futur
          let formatTime = date_values[0].opens_at.split(":");
          time = date_element.isSame(this.$moment(now.add(1, "day")), "day")
            ? `Tomorrow at ${formatTime[0]}:${formatTime[1]} `
            : `${date_element.format("dddd")} at ${formatTime[0]}:${formatTime[1]
            } `; //date_element.format("dddd") + " at " + date_values[0].opens_at;

          return time;
        }
      }
      return time;
    },
    searchLocationbyPostcode() {
      this.isLoadingSearch = true;
      this.searchError = false;

      this.fetchLocationsByPostCode(this.searchPostcode)
        .then((response) => {
          if (response && response.error) {
            this.searchError = true;
            this.searchErrorText = response.error;
            this.hasCompletedPostcodeLookup = true;
            this.isLoadingSearch = false;
            this.savePostcode('')
            return;
          }

          const locationsInRange = response.data.data.filter(
            //({ delivery_fee }) => delivery_fee !== null && delivery_fee >= 0
            ({ availabe_delivery_postcode }) =>
              availabe_delivery_postcode === true
          );

          if (locationsInRange.length === 0) {
            this.searchError = true;
            this.searchErrorText = this.$t("message.delivery_not_avaialable");
            this.filteredLocations = [];
            if (this.multiLocations)
              this.storeSelectedLocation(null);

            this.savePostcode('')
            this.isLoadingSearch = false;

            return true;
          }
          if (locationsInRange.length === 1) {
            // TODO : check if the location is not closed and can offer the delivery (now, or pre-ordering) before redirecting the user, otherwise display a message
            let location_status = canMakeOrder(locationsInRange[0], true);
            if (!location_status.can_accept_delivery) {
              this.searchError = true;
              this.searchErrorText = this.$t("message.delivery_to_area_closed");
              this.filteredLocations = [];
              this.hasCompletedPostcodeLookup = true;
              this.isLoadingSearch = false;
              return;
            }
            this.filteredLocations = locationsInRange;
            this.location_id = locationsInRange[0].id;
            this.savePostcode(this.searchPostcode)
            this.getLocation();
            this.isLoadingSearch = false;

            return true;
          }

          if (locationsInRange.length > 1) {
            this.filteredLocations = locationsInRange;
            this.savePostcode(this.searchPostcode)
          }
          this.hasCompletedPostcodeLookup = true;
          this.isLoadingSearch = false;
        })
        .catch((e) => {
          this.captureException(e);
          this.hasCompletedPostcodeLookup = true;
          this.isLoadingSearch = false;
          this.searchError = true;
          this.filteredLocations = null;
          this.savePostcode('')
          this.searchErrorText = getMessageFromAPIError(
            e ? e.data : {},
            this.$t("generic_error.delivery_search_error")
          );
        });
    },
    setLocation() {
      // check if the user change the location , check if the user have already some items in the basket, we display a message confirmation :
      // if Continue : cleare the bascket and save the new location
      // cancel : don't do anything
      //****** get last location data */
      if (
        !this.isLocationEmpty() &&
        this.selectedLocation.id != this.location_id &&
        this.newCart.order.length
      ) {
        let self = this;
        let message =
          "<div><i class='k-icon-faq big-icon' style='color:" +
          self.staticColor.black +
          "' ></i></div>" +
          `<div class='dg-content-body-text'>${this.$t(
            "message.items_from_different_location"
          )}</div>`;

        let options = {
          html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
          okText: this.$t("button.yes_continue"),
          cancelText: this.$t("button.cancel"),
          animation: "fade", // Available: "zoom", "bounce", "fade"
          type: "basic", // coming soon: 'soft', 'hard'
          backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
          customClass: "confirm", // Custom class to be injected into the parent node for the current dialog instance
        };
        this.$dialog.confirm(message, options).then(async function () {
          await self.resetOrderFromDifferentLocation();
          cartManager.saveSelectedLocation(
            self.filteredLocations,
            self.location_id,

          );
          if (
            self.newCart.orderType == ORDER_TYPE.Table.id &&
            !self.selectedLocation.tables.length
          ) {
            return;
          }
          this.$router.push("/menu");
        });
      } else {
        cartManager.saveSelectedLocation(
          this.filteredLocations,
          this.location_id
        );
        this.$nextTick(function () {

          if (this.newCart.orderType == ORDER_TYPE.Table.id) {
            return;
          }
          this.$router.push("/menu");
        });
      }
    },
    getLocation() {
      if (this.newCart.orderType == ORDER_TYPE.Delivery.id) {
        if (this.postcode) {
          //**** get location by postcode */
          this.searchPostcode = this.postcode;
          this.fetchLocationsByPostCode(this.searchPostcode).then(() => {
            this.setLocation();
          });
        }
      } else {
        this.fetchTheme().then(() => {
          this.setLocation();
        });
      }
    },
    onOrderTypeChanged(value) {
      //*** get the location data to refresh */
      /**
       * From now on, we do not want to reset the cart value on change of order
       * type. Instead we will send user back to home page where they will
       * set the delivery details & then they will see the delivery charge
       * added to their cart along with the cart set in collection order type.
       */
      if (
        value === ORDER_TYPE.Delivery.id &&
        this.selectedLocation &&
        !this.selectedLocation.availabe_delivery_postcode
      ) {
        this.filteredLocations = this.availableLocations;

        this.savePostcode('')
        this.newCart.orderType = value;
        cartManager.setCart(this.newCart, true);
        if (!this.isHome) {
          this.$nextTick(() => this.$router.push("/"));
        }
      }
      //---- if the user change from a Collection to table or the opposite
      //==> check if the user have already items to the basket
      //==> if true, check any item price differences : true or false
      //==> if true, display a pop-up to the user ato ask if he want to change the order type and display the list of the items
      //---- init the arrays efore any chanck
      this.ItemsNotAvailable = [];
      this.ItemsWithDiffPrice = [];

      if (this.newCart.order.length && value != this.newCart.orderType) {
        this.newCart.order.forEach((item) => {
          if (!checkIfItemAvailbleByOrderType(value, item)) {
            this.ItemsNotAvailable.push(item);
          } else if (
            getMenuItemTotal(item, value) !=
            getMenuItemTotal(item, this.newCart.orderType)
          ) {
            //-- if the item is not availabe , so it'not necessary to chack for the prices differences
            this.ItemsWithDiffPrice.push(item);
          }
        });
        var showPopUp =
          !!this.ItemsNotAvailable.length || !!this.ItemsWithDiffPrice.length;
        if (showPopUp) {
          this.$root.$emit("OPEN_POPUP_CONFIRMATION", {
            ItemsWithDiffPrice: this.ItemsWithDiffPrice,
            ItemsNotAvailable: this.ItemsNotAvailable,
            NewOrderType: value,
            OldOrderType: this.newCart.orderType,
          });
        } else {
          this.callbackOrderTypeChanging(value);
        }
      } else {
        this.callbackOrderTypeChanging(value);
      }
    },
    callbackOrderTypeChanging(value) {
      return new Promise((resolve) => {
        this.filteredLocations = this.locations;
        this.location_id = null;

        this.$set(this.newCart, 'orderType', value)
        //---- Busines with Multiple Locations : filter the available Locations by orderType
        if (this.multiLocations) {
          this.filteredLocations = filterLocationsByOrderType(
            value,
            value === ORDER_TYPE.Delivery.id
              ? this.availableLocations
              : this.locations
          );

          if (this.filteredLocations.length == 1) {
            this.storeSelectedLocation(this.filteredLocations[0])
          }
        }

        //-- select the first location when the orderType is Table
        if (this.newCart.orderType == ORDER_TYPE.Table.id) {
          this.location_id =
            !this.multiLocations && this.selectedLocation
              ? this.selectedLocation.id
              : this.filteredLocations.length
                ? this.filteredLocations[0].id
                : null;
        }

        //-- if the user is in the Menu , and provide a coupon : appply the coupn again to check if it's available for the new selected order type:
        if (!this.isHome && this.newCart.coupon && this.newCart.order.length) {
          this.onSubmitCoupon(false, true);
        }

        //--- if the business have only one location and type is Collection, the user will be directly redirected to Menu
        if (
          this.isHome &&
          this.newCart.orderType == ORDER_TYPE.Collection.id &&
          !this.multiLocations //|| this.filteredLocations.length == 1
        ) {
          //--- closed the pop-up before redirecting the user
          this.$root.$emit("CLOSE_POPUP_CONFIRMATION");
          this.fetchCategories(this.selectedLocation.id);
          this.$nextTick(function () {
            this.$router.push("/menu");
          });
        }
        resolve();
      });
    },
    onLocationSelected() {
      this.getLocation();
    },
    onTableSelection: function (value) {
      // redirect the user to the Menu
      let _table = this.selectedLocation.tables.find((x) => x.id === value);
      this.newCart.table = {
        id: _table.id,
        name: _table.name,
      };
      cartManager.setCart(this.newCart, false);
      if (this.isHome) this.$router.push("/menu");
    },
    confirmChangeEventListner: function () {
      this.$root.$off("CONFIRM_CHANGES");
      this.$root.$on("CONFIRM_CHANGES", (NewOrderType) => {
        this.removeUnavailableItems().then(() => {
          this.callbackOrderTypeChanging(NewOrderType).then(() => {
            this.$root.$emit("CLOSE_POPUP_CONFIRMATION");
          });
        });
      });
    },
    removeUnavailableItems() {
      return new Promise((resolve) => {
        if (this.ItemsNotAvailable.length) {
          let self = this;
          this.newCart.order = this.newCart.order.filter(function (item) {
            return !self.ItemsNotAvailable.includes(item);
          });
        }
        resolve();
      });
    },
    validatePostcode: function (e) {
      if (e.keyCode === 13) {
        this.searchLocationbyPostcode();
      }
    },
    allLocationsClosed(type) {
      let res = this.locations.filter((location) => {
        let current_location_status = canMakeOrder(location, true);
        return (
          (type == ORDER_TYPE.Delivery.id &&
            (location.openingHours.delivery ||
              current_location_status.can_accept_delivery)) ||
          (type == ORDER_TYPE.Collection.id &&
            (location.openingHours.collection ||
              current_location_status.can_accept_collection)) ||
          (type == ORDER_TYPE.Table.id &&
            location.openingHours.sitIn &&
            current_location_status.can_accept_tableOrdering)
        );
      });
      return res.length <= 0;
    },
    businessAllowingTableOrdering() {
      let res = this.locations.filter((location) => {
        return location.orderSetting.offer_tableordering;
      });
      return res.length > 0;
    },
    resetOrderFromDifferentLocation() {
      return new Promise((resolve) => {
        this.newCart.order = [];
        this.newCart.status = STEP_STATUS.PREPARED;
        this.newCart.step = STEPS.STEP01;
        this.newCart.coupon_result = null;
        this.newCart.coupon_error = null;
        this.newCart.coupon = "";
        this.newCart.newOrder = null;
        this.newCart.id = null;
        this.newCart.service_charge = getServiceChargeByType(
          this.selectedLocation.service_charges,
          this.newCart.orderType,
          this.selectedLocation.orderSetting.service_charge
        );
        this.newCart.bag_charge = this.selectedLocation.orderSetting.bag_charge;
        cartManager.setCart(this.newCart, true);
        resolve(true);
      });
    },
  },
  created() {

    this.confirmChangeEventListner();
    this.searchPostcode = this.postcode

    if (this.newCart.status == STEP_STATUS.SAVED) {
      this.newCart.status = STEP_STATUS.PREPARED;
      this.newCart.step = STEPS.STEP01;
      this.newCart.newOrder = null;
      this.newCart.id = null;
      cartManager.setCart(this.newCart, true, false);
    }
  },
  mounted() {
    this.isMounted = true;
    if (this.newCart == null) {
      return;
    }

    this.filteredLocations = this.locations;

    if (this.isHome && this.multiLocations) {
      this.filteredLocations = filterLocationsByOrderType(
        this.newCart.orderType,
        this.newCart.orderType === ORDER_TYPE.Delivery.id
          ? this.availableLocations
          : this.locations
      );
    }
    if (
      !this.multiLocations &&
      this.isHome &&
      this.newCart.orderType == ORDER_TYPE.Table.id
    ) {
      this.location_id = this.selectedLocation.id;
    }
    if (
      !this.isHome &&
      this.newCart.orderType == ORDER_TYPE.Table.id &&
      this.newCart.table
    ) {
      this.table_id = this.newCart.table.id;
    }

    if (
      this.selectedLocation &&
      !this.isHome &&
      this.newCart.orderType == ORDER_TYPE.Delivery.id &&
      !this.selectedLocation.availabe_delivery_postcode
    ) {
      this.onOrderTypeChanged(ORDER_TYPE.Collection.id);
    }
  },
};
</script>
<style scoped>
.input-group,
.form-group {
  width: 100%;
}

.delivery-pickup-menu .btn-group,
.search-area,
.search-area .input-group {
  width: 100% !important;
  max-width: 530px;
}

.search-area h3,
.search-area p {
  width: 100% !important;
  margin: 0;
  text-align: center;
  font-weight: bold;
}

.delivery-pickup-menu .list-group-item {
  padding: 0;
}

.centered {
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-group.input-group {
  padding: 0;
}
</style>
<style>
.input-group .form-control:last-child {
  background: white;
}

.input-group-focus .form-control:last-child {
  outline: yellow;
}
</style>
